// removed by extract-text-webpack-plugin
module.exports = {"graphic":"Login__graphic___3_zQE","lettering":"Login__lettering___3SSC9"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/login/Login.css
// module id = 1178
// module chunks = 0